var map = {
	"./AMS.png": "5413",
	"./CST-S.png": "d5f3",
	"./PHA.png": "896e",
	"./ignis-logo-no-bg.png": "1c84",
	"./ignis-logo.png": "b701",
	"./pha-logo-small.png": "177e",
	"./pha-logo-white.png": "f752"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "818c";